import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Box, Text } from '@primer/react';
import ComponentLayout from '~/src/layouts/component-layout';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h2>{`Usage`}</h2>
    <p>{`The popover component is used to deliver context-specific information and functionality. It’s a small dialog to bring attention to specific user interface elements. It can provide additional information, options, or actions related to a specific element or task. Popovers can be helpful for flows that require light onboarding or instruction.`}</p>
    <p>{`Popovers may contain text, links, and buttons. `}</p>
    <p>{`Popover supports various caret positions, which you can specify, though the default is top. Note that the top-left, bottom-left, top-right, and bottom-right values modify the horizontal alignment of the popover.`}</p>
    <img src="https://user-images.githubusercontent.com/586552/227022626-625dad35-47d5-46ac-ba64-3c1285a37410.png" role="presentation" width="960" alt="A popover component example" />
    <h2>{`Best practices`}</h2>
    <p>{`Use sparingly to avoid cognitive overload. Though they can be used for a variety of things, they should be used sparingly to avoid cognitive overload. It's important to consider the context in which the popover appears. Are there other popovers on the page? Does it appear on page load, or require the user to open the popover?`}</p>
    <p>{`Unlike other messaging components, popovers should never include critical information (such as errors) and should always include a dismiss action.`}</p>
    <h2>{`Accessibility`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Popovers should be operable using the keyboard alone, without requiring the use of a mouse or other pointing device.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Popovers should be announced by screen readers, including their content and role on the page.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`When a popover is opened, focus should be moved to the popover so that keyboard users can interact with it. When the popover is closed, focus should be returned to the element that triggered it. For more on this, see the accessibility guidelines `}<a parentName="p" {...{
            "href": "/guides/accessibility/focus-management"
          }}>{`on focus management`}</a>{`.`}</p>
      </li>
    </ul>
    <h2>{`Related links`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../ui-patterns/feature-onboarding"
        }}>{`Feature onboarding`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      